export default {
    getUserInfo: import.meta.env.VITE_BASE_URL + '/user/token', // 获取用户信息
    uploadImage: 'https://api.sciconf.cn' + '/mall/common/upload-image-private' + '?v=' + new Date().getTime(), //上传图片
    userRegister: import.meta.env.VITE_BASE_URL + '/user/register', //注册
    userLogin: import.meta.env.VITE_BASE_URL + '/user/login', //登录
    getUserBaseInfo:import.meta.env.VITE_BASE_URL + '/user/info', // 获取用户基本信息|经历信息
    getReportInfo: import.meta.env.VITE_BASE_URL + '/train/get-report-info', // 根据报名id获取进修计划 | 上传证书
    getTrainList: import.meta.env.VITE_BASE_URL + '/train/list', // 获取培训班列表
    getTrainApplyList: import.meta.env.VITE_BASE_URL + '/train/apply-list', // 获取培训报名申请列表
    saveBasicInfo: import.meta.env.VITE_BASE_URL + '/train/report-basic-info', // 保存基本信息
    saveExperience: import.meta.env.VITE_BASE_URL + '/train/report-experience', // 保存经历
    savePlan: import.meta.env.VITE_BASE_URL + '/train/report-plan', // 保存进修计划
    submitCertFile: import.meta.env.VITE_BASE_URL + '/train/report-file', // 上传证书文件
    submitPayVoucher: import.meta.env.VITE_BASE_URL + '/train/pay-file', // 提交付款凭证
    submitEvaluate: import.meta.env.VITE_BASE_URL + '/train/report-evaluate', // 进修评价提交
    getPayGuide: import.meta.env.VITE_BASE_URL + '/train/pay-guide', // 获取缴费指南
    getPeriodList: import.meta.env.VITE_BASE_URL +  '/train/period-list', // 获取培训班期次列表
    getTrainDetail: import.meta.env.VITE_BASE_URL + '/train/detail', // 获取培训班详情
    delTrain: import.meta.env.VITE_BASE_URL + '/train/apply-del', // 删除培训班申请
    getReportFile: import.meta.env.VITE_BASE_URL + '/train/get-report-file', // 获取申请表文件pdf
    /**** 考勤请假 ****/
    getAttendList: import.meta.env.VITE_BASE_URL + '/attend/attend-list', // 获取考勤列表
    getHolidayList: import.meta.env.VITE_BASE_URL + '/attend/holiday-list', // 获取请假列表
    addHoliday: import.meta.env.VITE_BASE_URL + '/attend/holiday-add', // 请假申请
    removeHoliday: import.meta.env.VITE_BASE_URL + '/attend/holiday-ride', // 消假
    getHolidayInfo: import.meta.env.VITE_BASE_URL + '/attend/holiday-info', // 获取请假详情
    uploadAttendAdd: import.meta.env.VITE_BASE_URL + '/attend/attend-add', // 上传考勤

    getCommonConfig: import.meta.env.VITE_BASE_URL + '/user/config', //获取公共配置
    sendResetPassword: import.meta.env.VITE_BASE_URL + '/user/send-reset-password-email', // 发送重置验证码邮件
    resetPassword: import.meta.env.VITE_BASE_URL + '/user/reset-password' // 发送邮箱验证码
};
